// extracted by css-extract-rspack-plugin
export default {"linkContainer":"ModelLegalTerms-module__linkContainer__y65QnfD"};